__turbopack_context__.v({
  "article": "TopArticles-module-scss-module__BaW78q__article",
  "title": "TopArticles-module-scss-module__BaW78q__title",
  "topArticlesRoot": "TopArticles-module-scss-module__BaW78q__topArticlesRoot",
});
